import axios from 'axios';

var SingletonFactory = (function () {
  var instance;

  return {
    getInstance: function () {
      if (instance == null) {
        instance = axios.create();
      }
      return instance;
    },
    setupDefaults: function (options) {
      if (options.baseUrl) {
        instance.defaults.baseUrl = options.baseUrl;
      }
      instance.defaults.headers.post['Content-Type'] = 'application/json';

      // setup request interceptor for auth header
      instance.interceptors.request.use((config) => {
        if (config.skipAuthHeaders == undefined || !config.skipAuthHeaders) {
          config.headers['Authorization'] = options.core.getAuthHeader();
        }
        return config;
      });

      // cancel tokens
      instance.CancelToken = axios.CancelToken;
      instance.isCancel = axios.isCancel;
    },
  };
})();

const setupDefaultsAxiosInstance = SingletonFactory.setupDefaults;

export default SingletonFactory.getInstance();
export { setupDefaultsAxiosInstance };
